import request from 'utils/request'
/*---------  客户管理中心详情    -------*/
// riskLabel/list 获取风险标签下拉框
export const getrisk = data => request().post('riskLabel/list', data)
//客户概览
export const getCustomerOverview = id =>
  request().get(`customer/overview/${id}`)
//客户详情查询
export const customerDetail = id => request().get(`customer/query/${id}`)
//信用主管
export const getListCManager = () => request().get('bp/apply/listCManager')
//保存-企业地址信息
export const addAddress = data => request().post('customer/address/add', data)
//保存-企业账户管理
export const addAccount = data => request().post('customer/account/add', data)
//保存-企业额外信息
export const addCuntomerDetails = data =>
  request().post('customer/addDetails', data)
//新增联系人
export const addShareholders = data => request().post('creditmanager/add', data)

//下载
export const donwloadBackground = id =>
  request().get(`customer/background/download/${id}`, { responseType: 'blob' })
//客户信息导出
export const exportClient = id =>
  request().get(`customer/export/${id}`, { responseType: 'blob' })
//保存-企业基本信息
export const addCuntomer = data => request().post('customer/add', data)
//业务类型
export const getBusinessList = () => request().get('business/jsonList')
/**
 * 获取 大区 | 业务模式 | 信控区列表
 */
export const getRegionList = data =>
  request().post('business/region/list', data)
// 获取国家
export const getCountry = data =>
  request().get('sovereign/rate/getCountry', data)
// 查询
export const getCreditmanager = code =>
  request().get(`creditmanager/query/${code}`)
// 删除
export const remove = id => request().get(`creditmanager/delete/${id}`)

// 获取业务类型冻结列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

// 获取业务模式冻结列表
export const getFreezeModelList = () =>
  request().get('business/jsonList/getFreezeModelList')

// 获取评分卡LIST[] ,不包含“冻结”状态的
export const getRating = () => request().post('card/selectRating/list')
